import { useState } from 'react';
import _ from 'lodash';

export const useLocalStorage = (keyName, defaultValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = window.localStorage.getItem(keyName);
      if (!_.isNil(value)) {
        return JSON.parse(value);
      } else {
        window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  });
  const setValue = (newValue) => {
    try {
      if (_.isString(newValue)) {
        window.localStorage.setItem(keyName, newValue);
      } else {
        window.localStorage.setItem(keyName, JSON.stringify(newValue));
      }
    } catch (err) { /* empty */ }
    setStoredValue(newValue);
  };
  return [storedValue, setValue];
};